/**
 * 存储localStorage
 */
export const setLocalStorage = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getLocalStorage = name => {
	if (!name) return;
	let data = window.localStorage.getItem(name)

	return data ? JSON.parse(data) : undefined;
}

/**
 * 删除localStorage
 */
export const removeLocalStorage = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

export const Storage = {
	/**
	 * getCookie
	 * @param name
	 * @returns {*}
	 */
	get(name) {
		if (!name) return;
		let data = window.localStorage.getItem(name)
		return data;
	},

	/**
	 * 添加cookie
	 * @param name
	 * @param value
	 * @param expiresHours
	 * @param domain
	 */
	set(name, value) {
		if (!name) return;
		if (typeof value !== 'string') {
			value = JSON.stringify(value);
		}
		window.localStorage.setItem(name, value);
	},

	/**
	 * 删除cookie
	 * @param name
	 */
	remove(name) {
		if (!name) return;
		window.localStorage.removeItem(name);
	}
}
export const Cookie = {
	/**
	 * getCookie
	 * @param name
	 * @returns {*}
	 */
	get(name) {
		var strCookie = document.cookie;
		var arrCookie = strCookie.split("; ");
		for (var i = 0; i < arrCookie.length; i++) {
			var arr = arrCookie[i].split("=");
			if (arr[0] == name) return arr[1];
		}
		return "";
	},

	/**
	 * 添加cookie
	 * @param name
	 * @param value
	 * @param expiresHours
	 * @param domain
	 */
	set(name, value, expiresDays, domain, path) {
		var cookieString = name + "=" + (value ? value : '');
		var date = new Date();

		if (domain != undefined)
			domain = ";domain=" + domain;
		else
			domain = '';

		date.setTime(date.getTime() + (expiresDays || 1) * 24 * 3600 * 1000);
		cookieString = cookieString + domain + "; path="+ (path || "/") +"; expires=" + date.toGMTString();

		document.cookie = cookieString;
	},

	/**
	 * 删除cookie
	 * @param name
	 */
	remove(name) {
		this.set(name, '', -1);
	}
};

/**
 * 权限对比
 * @param matchArr
 * @param userArr
 * @returns {boolean}
 */
export function authorityComparison(matchArr, userArr) {
	if(!userArr){ // 如果没有设置权限码，默认不需要
		return true;
	}
	let temp = false;
	matchArr = matchArr || []
	if(typeof userArr === 'string' || typeof userArr === 'number'){
		return matchArr.includes(userArr);
	}else{
		userArr.forEach(item => {
			temp = temp || matchArr.includes(item);
		})
	}
	return temp;
}
/**
 * 时间格式方法
 *
 * @param {any} timeStamp  时间戳，秒级/毫秒级
 * @param {any} type 格式化时间类型，默认  Y-M-D H:I:S
 * @returns {string} formatTime 格式化后的时间 例如： 2017-05-05 12:09:22
 */
export function formatDate(nS, str) {
    if (!nS) {
        return "";
    }
    // 2018-11-13T02:51:50.000+0000
    if(typeof nS === 'string'){
      nS = nS.toString();
      nS = nS.replace('T', ' ').replace(/\.[0-9][0-9][0-9]/g, ' GMT');
      nS=nS.replace(new RegExp(/-/gm) ,"/");
    }

    var date = new Date(nS);
    var year = date.getFullYear();
    var mon = date.getMonth() + 1;
    var day = date.getDate();
    var hours = date.getHours();
    var minu = date.getMinutes();
    var sec = date.getSeconds();

    if (str == 'yyyy-MM-dd') {
        return year + '-' + (mon < 10 ? '0' + mon : mon) + '-' + (day < 10 ? '0' + day : day);
    } else if (str == 'hh-mm-ss') {
        return (hours < 10 ? '0' + hours : hours) + ':' + (minu < 10 ? '0' + minu : minu) + ':' + (sec < 10 ? '0' + sec : sec);
    } else if (str == 'yyyy/MM/dd') {
        return year + '/' + (mon < 10 ? '0' + mon : mon) + '/' + (day < 10 ? '0' + day : day);
    } else {
        return year + '-' + (mon < 10 ? '0' + mon : mon) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hours < 10 ? '0' + hours : hours) + ':' + (minu < 10 ? '0' + minu : minu) + ':' + (sec < 10 ? '0' + sec : sec);
    }

}
/*  格式化 年月日*/
export function getcurrentDate(nS) {
	var date = nS ? new Date(nS) : new Date();
	var year = date.getFullYear();
	var mon = date.getMonth() + 1;
	mon = mon > 9 ? mon : '0' + mon;
	var day = date.getDate();
	day = day > 9 ? day : '0' + day;
	return '' + year + '-' + mon + '-' + day;
}
